import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'
import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { FilesPreviewerContextValue } from 'modules/expenses/components/expenses/Detail/hooks/useFilesPreviewer'
import { CustomizationField } from 'modules/expenses/hooks/useExpensesCustomization'

import { isMandatory } from '../../withCustomizationFields'

const defaultRequiredMessage = () => ({
  message: i18n.t('expenses_v2.forms.errors.required'),
})
export interface FormContext {
  customizationFields: CustomizationField[]
  hasSignedDocuments?: boolean
  previewer?: FilesPreviewerContextValue
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
}

export const FilesSchema = ({
  customizationFields,
  hasSignedDocuments,
  previewer,
  resourceType,
}: FormContext) => {
  return z.object({
    files: z.array(z.any()).refine((files) => {
      return isMandatory('files', resourceType, customizationFields, 'default')
        ? files.length > 0 || (previewer && previewer.files.length > 0) || hasSignedDocuments
        : true
    }, defaultRequiredMessage()),
    filesIdToRemove: z.array(z.number()),
  })
}

export type FilesSchema = z.infer<ReturnType<typeof FilesSchema>>
